import React from 'react';
import moment from 'moment';
import Calendar from '../components/Calendar';
import './style/App.css';

moment.locale('it');

class App extends React.Component {
    static propTypes = {
    }
    render() {
        return (
            <Calendar />
        );
    }
}

export default App;
